module.exports = __webpack_public_path__ + "img/3.4692895d.jpg";